<template>
  <div>
    <NavBreadCrumb class="mb-12 lg:mb-16" />
    <section class="container flex justify-center">
      <div
        class="hidden h-full min-w-[288px] max-w-[288px] overflow-y-auto bg-grey-50 pb-4 pl-4 lg:block"
      >
        <SbHelpCentreSidebarContent :search-input="true" />
      </div>
      <div class="lg:ml-16">
        <SearchTagInput :title="tag" :tag="tag" sort-priority="Help Centre" />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
const route = useRoute();
const capitaliseSlug = (slug: string) =>
  slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const tag = capitaliseSlug(route.params.slug[0]);

const metaStore = useMetaStore();
metaStore.pageTitle = `${tag} | Aussie Broadband`;
metaStore.metaTitle = `${tag} | Aussie Broadband`;

metaStore.metaDescription = `Articles about ${tag} in the Help Centre`;
</script>
